import utils from '@/app/utils/gfUtils';

(function (jQuery) {
  jQuery.gfModalNew = function (element, options) {
    const defaults = {
      bg: 'rgba(0,0,0,0.4)',
      overlayClick: true,

      width: 960,
      minHeight: '',
      height: '',
      left: 'auto',
      top: 'auto',
      right: 'auto',
      bottom: 'auto',
      center: false,
      loading: false,

      topOverlay: '', // margin top để cho phép click vào button close
      heightOverLay: '100%', // heightOverLay tùy chỉnh

      saveLabel: 'Save',
      cancelLabel: 'Cancel',
      insertLabel: 'Insert',
      backLabel: 'Back to Library',
      addLabel: '',

      minimizedHeader: false,
      contentClass: '',

      zIndex: '999999',

      header: '',
      footer: '',
      title: 'DEMO',
      onSubHeader: false,

      tabs: [],
      selectTab: '',

      onContent: function ($content) {},
      onSave: function () {},
      onCancel: function () {},
      onClose: function () {},
      onResume: function () {},
      onInsert: function () {},
      onAdd: function () {},
      onTabSelected: function (tab, $tabContent) {},
      svgIconClose: 'clear-large'
    };

    const _templateLoader =
      '<div class="gf_modal-loader-body">' +
      '<div class="gf_modal-loader">' +
      '<div class="gfLoader-frame">' +
      '<div class="gfLoader-Circle">' +
      '<svg class="gfLoader-Circle-shape" viewBox="25 25 50 50">' +
      '<circle class="gfLoader-Circle-track" cx="50" cy="50" r="23" fill="none" stroke-width="1.5" stroke-miterlimit="10" stroke="rgba(10,10,58,0.1)"/>' +
      '<circle class="gfLoader-Circle-path" cx="50" cy="50" r="23" fill="none" stroke-width="1.5" stroke-miterlimit="10"/>' +
      '</svg>' +
      '</div>' +
      '<div class="gfLoader-ColorfulLogo">' +
      '<svg class="gfLoader-ColorfulLogo-shape" viewBox="0 0 28 28">' +
      '<path d="M26.7,2c0.1,0,0.1,0,0.2,0s0.1,0.1,0,0.2c-0.7,2.1-1.6,4.2-2.6,6.2c-0.4,0.7-1.1,1.3-1.9,1.6L5.1,15.2c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1L3,9.3c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1L26.7,2zM21.2,12.2c0.1,0,0.1,0,0.2,0s0.1,0.1,0,0.2c-0.6,1.8-1.3,3.6-2.2,5.2c-0.3,0.6-0.9,1.1-1.6,1.3l-9.3,2.8c-0.1,0-0.2,0-0.2-0.1l-1.5-4.9c0-0.1,0-0.2,0.1-0.2L21.2,12.2z M15.1,21.3c0,0,0.1,0,0.1,0s0,0.1,0,0.1c-0.5,1.5-1.1,3-1.9,4.4c-0.3,0.5-0.8,0.9-1.4,1.1l-0.8,0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1L9.7,23c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1L15.1,21.3z"/>' +
      '</svg>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';
    const _templateConfirm = '<div class="gf_modal-confirm"></div>';
    let _templateHeader = '';
    let _templateFooter = '';
    let _template = '';
    let _onFooter = false;
    const _dataTab = [];

    this.settings = {};
    const _this = this;

    var $element = jQuery(element),
      element = element;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      _this.setHeader(_this.settings.header);
      _this.setFooter(_this.settings.footer);
      _this.onInitModal();
    };

    this.onShow = function () {
      const $modelBody = $element.find('.gf_modal');
      if ($modelBody.length == 0) {
        _this.onInitModal();
      }
      $modelBody.addClass('gf_modal-show');
      _this.settings.onResume();

      return false;
    };
    this.onClose = function () {
      _this.settings.onClose();

      const $modelBody = $element.find('.gf_modal');
      $modelBody.removeClass('gf_modal-show');

      _this.settings.onSubHeader = false;
      return false;
    };

    this.onLoading = function () {
      const heightOverlay = _this.settings.heightOverLay;
      const $gfModalLoaderBody = $element.find('.gf_modal-loader-body');
      if (heightOverlay !== '100%') {
        $gfModalLoaderBody.css('height', heightOverlay).addClass('gf_modal-show');
      } else {
        $gfModalLoaderBody.addClass('gf_modal-show');
      }

      const topOverlay = _this.settings.topOverlay;
      if(topOverlay) {
        $gfModalLoaderBody.css('top', topOverlay);
      }
      return false;
    };

    this.offLoading = function () {
      $element.find('.gf_modal-loader-body').removeClass('gf_modal-show');
      return false;
    };

    this.onInitModal = function () {
      let divContentTab = '';
      if (_this.settings.tabs.length > 0) {
        for (let i = 0; i < _this.settings.tabs.length; i++) {
          if (_this.settings.selectTab == _this.settings.tabs[i]) {
            divContentTab +=
              '<div class="gf_modal-body-tab" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" style="display:block"></div>';
          } else {
            divContentTab +=
              '<div class="gf_modal-body-tab" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" style="display:none"></div>';
          }
        }
      }

      const bg = _this.settings.bg;
      const zIndex = _this.settings.zIndex;

      let width = _this.settings.width;

      let center = _this.settings.center;
      if (center) {
        center = 'margin:0px auto;';
      } else {
        center = '';
      }
      let left = _this.settings.left;
      let right = _this.settings.right;
      let top = _this.settings.top;
      let bottom = _this.settings.bottom;
      // new attribute
      let minimizedHeader = _this.settings.minimizedHeader;
      if (minimizedHeader) {
        minimizedHeader = ' header-minimized';
      }
      let contentClass = _this.settings.contentClass;
      if (contentClass && contentClass.length) {
        contentClass = ' ' + contentClass;
      }

      let transform = '';
      if (center) {
        if (_this.settings.height !== '') {
          top = (jQuery(window).height() - (_this.settings.height + 48)) / 2;
          left = jQuery(window).width() / 2;
          transform = 'transform: translateX(-50%);';
        } else {
          top = jQuery(window).height() / 2;
          left = jQuery(window).width() / 2;
          transform = 'transform: translate(-50%,-50%);';
        }
      }

      if (top + parseInt(_this.settings.height) + 48 > jQuery(window).height()) {
        _this.settings.height = 0.8 * jQuery(window).height();
      }
      if (parseInt(width) + 100 > jQuery(window).width()) {
        width = 0.98 * jQuery(window).width();
      }

      if (left !== 'auto') {
        left += 'px';
      }
      if (right !== 'auto') {
        right += 'px';
      }
      if (top !== 'auto') {
        top += 'px';
      }
      if (bottom !== 'auto') {
        bottom += 'px';
      }

      _template = ' <div class="gf_modal" style="background-color:' + bg + ';z-index:' + zIndex + ';">';
      _template +=
        '<div class="gf_modal-content ' +
        minimizedHeader +
        contentClass +
        '" style="width:' +
        width +
        'px;' +
        center +
        'left:' +
        left +
        ';top:' +
        top +
        ';bottom:' +
        bottom +
        ';right:' +
        right +
        ';' +
        transform +
        '">' +
        _templateHeader;
      _template += '<div class="gf_modal-header gf_modal-header-preview">';
      _template += '<div class="gf_modal-left gf_modal-left-subheader gf_modal-back-off-preview">';
      _template +=
        '<i class="icon-back-right gf_modal-back-off-preview"><svg style="width:16px;height:16px" viewBox="0 0 24 24"><path fill="%23000000" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" /></svg></i>';
      _template += '<p class="gf_modal-back-off-preview">' + _this.settings.backLabel + '</p>';
      _template += '</div>';
      _template +=
        '<button class="gf_modal-insert" data-action="insert-from-lib" type="button"> <span>' +
        _this.settings.insertLabel +
        '</span> <svg width="8" viewBox="0 0 8 10"><path d="M3,0v4H0l4,4l4-4H5V0H3z M0,10h8V9H0V10z"></path></svg> </button>';
      _template += '<div class="gf_modal-right">';
      _template +=
        '<button class="gf_modal-close-btn" data-action="close" type="button">' +
        utils.svgIcon(_this.settings.svgIconClose) +
        '</button>';
      _template += '</div>';
      _template += '</div>';
      if (_onFooter) {
        var height = 'calc(' + _this.settings.height + 'px - 73px)';
      } else {
        var height = _this.settings.height + 'px';
      }
      _template +=
        '<div class="gf_modal-body gf_modal-body-main"  style="height:' +
        height +
        ';min-height:' +
        _this.settings.minHeight +
        ';background:' +
        _this.settings.background +
        '">' +
        divContentTab +
        '</div>';
      _template +=
        '<div class="gf_modal-body gf_modal-body-sub" style="height:' +
        height +
        ';min-height:' +
        _this.settings.minHeight +
        '"></div>';
      _template += _templateConfirm + ' ' + _templateFooter + ' ' + _templateLoader;
      _template += '<div style="clear:both"></div>';
      _template += '</div>';
      _template += '</div>';

      $element.html(_template);

      //add optiscroll
      $element.find('.gf_modal-body.gf_modal-body-main').addClass('optiscroll').optiscroll();
      this.$element = $element;
      this.$modalBodyMain = $element.find('.gf_modal-body.gf_modal-body-main');
      if (_this.settings.tabs.length > 0) {
        if (_this.settings.selectTab) {
          if (_dataTab.indexOf(_this.settings.selectTab) < 0) {
            _this.onLoading();
          }
          _dataTab.push(_this.settings.selectTab);
          _this.setContentTab(_this.settings.selectTab);
        } else {
          // SelectTab not available
        }
      } else {
        if (_this.settings.loading) {
          _this.onLoading();
        }
        _this.setContent();
      }
      if (_this.settings.onSubHeader) {
        _this.onPreview();
      } else {
        _this.offPreview();
      }

      // apply events
      _this.applyEvents();

      return false;
    };

    this.toSlug = function (text) {
      return text
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
    };

    this.activeTab = function (activeTab) {
      const $tabContent = $element.find('.gf_modal-tab');
      $tabContent.removeClass('active');
      const $tabActive = $element.find('.gf_modal-tab[data-tab=' + _this.toSlug(activeTab) + ']');
      $tabActive.addClass('active');
      $element.find('.gf_modal-body-tab[data-tab=' + _this.toSlug(_this.settings.selectTab) + ']').css({
        display: 'none',
      });
      // show active tab
      _this.settings.selectTab = activeTab;
      $element.find('.gf_modal-body-tab[data-tab=' + _this.toSlug(_this.settings.selectTab) + ']').css({
        display: 'block',
      });
      if (_dataTab.indexOf(_this.settings.selectTab) < 0) {
        _this.onLoading();
      }
      if (_dataTab.indexOf(activeTab) < 0) {
        _dataTab.push(activeTab);
        _this.setContentTab(activeTab);
      } else {
        _dataTab.splice(_dataTab.indexOf(activeTab), 1);
        _dataTab.push(activeTab);
        _this.setContentTab(activeTab);
      }
      return false;
    };

    this.setContentTab = function (tab) {
      _this.offConfirm();
      const $tab = $element.find('.gf_modal-body-tab[data-tab=' + _this.toSlug(tab) + ']');
      _this.settings.onTabSelected(tab, $tab);
      return false;
    };

    this.setContent = function () {
      const $content = $element.find('.gf_modal-body-main');
      _this.settings.onContent($content);
      return false;
    };

    this.setContentConfirm = function ($content) {
      $('.gf_modal-confirm').html($content);
      $('.gf_modal-confirm').click(function (e) {
        if ($(e.target).is('.gf_modal-confirm')) {
          _this.offConfirm();
        }
      });
      return false;
    };

    this.onConfirm = function () {
      $element.find('.gf_modal-confirm').css({
        display: 'block',
      });
      return false;
    };

    this.offConfirm = function () {
      $element.find('.gf_modal-confirm').css({
        display: 'none',
      });
      return false;
    };

    this.setHeader = function (choose) {
      if (choose == 'header') {
        var tabs = '';
        for (var i = 0; i < _this.settings.tabs.length; i++) {
          if (_this.settings.tabs[i] == _this.settings.selectTab) {
            tabs +=
              '<a class="gf_modal-tab active" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" data-active-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i].toLowerCase() +
              '</a>';
          } else {
            tabs +=
              '<a class="gf_modal-tab" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" data-active-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i].toLowerCase() +
              '</a>';
          }
        }
        _templateHeader = '<div class="gf_modal-header" id="gf_modal-header">';
        _templateHeader += '<div class="gf_modal-left">';
        _templateHeader += '<i class="icon-libarary"></i>';
        _templateHeader += '<p>' + _this.settings.title + '</p>';
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-center">';
        _templateHeader += '<nav class="gf_modal-tabs">' + tabs + '</nav>';

        _templateHeader += '<div class="gf_modal-close-btn">' + utils.svgIcon(_this.settings.svgIconClose) + '</div>';

        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-right">';
        // _templateHeader += '<button class="gf_modal-close" data-action="close" type="button"></button>';
        _templateHeader += '</div>';
        _templateHeader += '</div>';
      } else if (choose == 'close') {
        _templateHeader = '<div class="gf_modal-header-close" id="gf_modal-header" style="' + styleHeader + '">';
        _templateHeader += '<div class="right">';
        _templateHeader += '<button class="gf_modal-close" data-action="close" type="button"></button>';
        _templateHeader += '</div>';
        _templateHeader += '</div>';
      } else if (choose == 'noLogo') {
        var tabs = '';
        for (var i = 0; i < _this.settings.tabs.length; i++) {
          if (_this.settings.tabs[i] == _this.settings.selectTab) {
            tabs +=
              '<a class="gf_modal-tab active" data-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i] +
              '</a>';
          } else {
            tabs +=
              '<a class="gf_modal-tab" data-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i] +
              '</a>';
          }
        }
        _templateHeader = '<div class="gf_modal-header" id="gf_modal-header">';
        _templateHeader += '<div class="gf_modal-center">';
        _templateHeader += '<nav class="gf_modal-tabs gf_modal-float-left"> ' + tabs + '</nav>';
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-right">';
        _templateHeader += '<button class="gf_modal-close" data-action="close" type="button"></button>';
        _templateHeader += '</div>';
        _templateHeader += '</div>';
      } else if (choose == 'noIcon') {
        var tabs = '';
        for (var i = 0; i < _this.settings.tabs.length; i++) {
          if (_this.settings.tabs[i] == _this.settings.selectTab) {
            tabs +=
              '<a class="gf_modal-tab active" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" data-active-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i] +
              '</a>';
          } else {
            tabs +=
              '<a class="gf_modal-tab" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" data-active-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i] +
              '</a>';
          }
        }
        _templateHeader = '<div class="gf_modal-header" id="gf_modal-header">';
        _templateHeader += '<div class="gf_modal-left">';
        _templateHeader += '<p>' + _this.settings.title + '</p>';
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-center">';
        _templateHeader += '<nav class="gf_modal-tabs">' + tabs + '</nav>';
        if (_this.settings.addLabel.length > 0) {
          _templateHeader += '<button class="gf_modal-add" type="button">' + _this.settings.addLabel + '</button>';
        }
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-right">';
        _templateHeader +=
          `<button class="gf_modal-close" data-action="close" type="button">${_this.settings.svgIconClose ? utils.svgIcon(_this.settings.svgIconClose) : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4966 7.50336C16.7746 7.78135 16.7746 8.23207 16.4966 8.51007L13.0067 12L16.4966 15.4899C16.7746 15.7679 16.7746 16.2186 16.4966 16.4966C16.2186 16.7746 15.7679 16.7746 15.4899 16.4966L12 13.0067L8.51007 16.4966C8.23207 16.7746 7.78135 16.7746 7.50336 16.4966C7.22536 16.2186 7.22536 15.7679 7.50336 15.4899L10.9933 12L7.50336 8.51007C7.22536 8.23207 7.22536 7.78135 7.50336 7.50336C7.78135 7.22536 8.23207 7.22536 8.51007 7.50336L12 10.9933L15.4899 7.50336C15.7679 7.22536 16.2186 7.22536 16.4966 7.50336Z" fill="#494949"/></svg>'}</button>`;
        _templateHeader += '</div>';
        _templateHeader += '</div>';
      } else if (choose == 'noTab') {
        _templateHeader = '<div class="gf_modal-header" id="gf_modal-header">';
        _templateHeader += '<div class="gf_modal-left">';
        _templateHeader += '<i class="icon-libarary"></i>';
        _templateHeader += '<p>' + _this.settings.title + '</p>';
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-right">';
        _templateHeader += '<button class="gf_modal-close" data-action="close" type="button"></button>';
        _templateHeader += '</div>';
        _templateHeader += '</div>';
      } else if (['productSelector', 'collectionSelector'].includes(choose)) {
        var tabs = '';
        for (var i = 0; i < _this.settings.tabs.length; i++) {
          if (_this.settings.tabs[i] == _this.settings.selectTab) {
            tabs +=
              '<a class="gf_modal-tab active" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" data-active-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i] +
              '</a>';
          } else {
            tabs +=
              '<a class="gf_modal-tab" data-tab="' +
              _this.toSlug(_this.settings.tabs[i]) +
              '" data-active-tab="' +
              _this.settings.tabs[i] +
              '" href="#">' +
              _this.settings.tabs[i] +
              '</a>';
          }
        }
        _templateHeader = '<div class="gf_modal-header" id="gf_modal-header">';
        _templateHeader += '<div class="gf_modal-left">';
        _templateHeader += '<p>' + _this.settings.title + '</p>';
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-center">';
        _templateHeader += '<nav class="gf_modal-tabs">' + tabs + '</nav>';
        if (_this.settings.addLabel.length > 0) {
          _templateHeader += '<button class="gf_modal-add" type="button">' + _this.settings.addLabel + '</button>';
        }
        _templateHeader += '</div>';
        _templateHeader += '<div class="gf_modal-right">';
        _templateHeader +=
          '<button class="gf_modal-reload" data-action="close" type="button"><span class="icon icon-refresh"></span></button>';
        _templateHeader +=
          '<button class="gf_modal-close" data-action="close" type="button"><span class="icon icon-cancel"></span></button>';
        _templateHeader += '</div>';
        _templateHeader += '</div>';
      }
      return false;
    };

    this.setFooter = function (choose) {
      if (choose == 'footer') {
        _onFooter = true;
        _templateFooter = '<div class="gf_modal-footer">';
        if (_this.settings.saveLabel != '') {
          _templateFooter += '<button class="gf_modal-btnSave">' + _this.settings.saveLabel + '</button>';
        }
        if (_this.settings.cancelLabel != '') {
          _templateFooter += '<button class="gf_modal-btnCancel">' + _this.settings.cancelLabel + '</button>';
        }
        _templateFooter += '</div>';
      }
      return false;
    };

    this.onPreview = function (content, button, from) {
      $('.gf_modal-insert').css({
        display: 'none',
      });
      // _this.onLoading();
      $element.find('.gf_modal-header').removeClass('gf_modal-show');
      $element.find('.gf_modal-body').removeClass('gf_modal-show');

      $element.find('.gf_modal-body-sub').addClass('gf_modal-show');
      $element.find('.gf_modal-header-preview').addClass('gf_modal-show');
      const bodySubbody = $element.find('.gf_modal-body-sub');
      $(bodySubbody).html(content);
      const $iframe = $('.gf_modal-body-sub').find('iframe');
      if ($iframe.length > 0) {
        $iframe.on('load', function () {
          _this.offLoading();
        });
      } else {
        _this.offLoading();
      }

      $element.find('.gf_modal-body .gf_app-details-wrapper .gf_app-details-left').addClass('optiscroll').optiscroll();
      return false;
    };

    this.offPreview = function () {
      $element.find('.gf_modal-body').addClass('gf_modal-show');
      $element.find('.gf_modal-header').addClass('gf_modal-show');
      $element.find('.gf_modal-body-sub').removeClass('gf_modal-show');
      $element.find('.gf_modal-header-preview').removeClass('gf_modal-show');
      return false;
    };

    this.applyEvents = function () {
      const $buttonClose = $element.find('.gf_modal-close, .gf_modal-close-btn');
      $buttonClose.off('click').on('click', function () {
        _this.onClose();
      });
      if (_this.settings.overlayClick) {
        const $bodyClose = $element.find('.gf_modal');
        $bodyClose.off('mousedown.close').on('mousedown.close', function (e) {
          if ($(e.target).closest('.gf_modal-content').length == 0) {
            _this.onClose();
          }
        });
      }

      const $tabContent = $element.find('.gf_modal-tab');
      $tabContent.off('click').on('click', function () {
        $tabContent.removeClass('active');
        $(this).addClass('active');
        const tab = $(this).attr('data-active-tab');
        $element.find('.gf_modal-body-tab[data-tab=' + _this.toSlug(_this.settings.selectTab) + ']').css({
          display: 'none',
        });
        // show active tab
        _this.settings.selectTab = tab;
        $element.find('.gf_modal-body-tab[data-tab=' + _this.toSlug(_this.settings.selectTab) + ']').css({
          display: 'block',
        });
        if (_dataTab.indexOf(tab) < 0) {
          _this.onLoading();
          _dataTab.push(tab);
          _this.setContentTab(tab);
        } else {
          _this.setContentTab(tab);
        }
      });

      const $btnCancel = $element.find('.gf_modal-btnCancel');
      $btnCancel.off('click').on('click', function () {
        _this.settings.onCancel();
      });

      const $btnSave = $element.find('.gf_modal-btnSave');
      $btnSave.off('click').on('click', function () {
        _this.settings.onSave();
      });

      const $btnOffPreview = $element.find('.gf_modal-back-off-preview');
      $btnOffPreview.off('click').on('click', function () {
        _this.offPreview();
      });

      const $btnInsert = $element.find('.gf_modal-insert');
      $btnInsert.off('click').on('click', function () {
        _this.settings.onInsert();
      });

      const $btnAdd = $element.find('.gf_modal-add');
      $btnAdd.off('click').on('click', function () {
        _this.settings.onAdd();
      });

      setTimeout(function () {
        $element.find('.gf_modal-content').gfModalDraggable({
          handle: '.gf_modal-header',
        });
        $element.find('.gf_modal-content').gfModalDraggable({
          handle: '.gf_modal-draggable',
        });
      }, 100);

      return false;
    };

    this.markAsLoaded = function (tab) {
      tab = tab.toUpperCase();
      if (_dataTab.indexOf(tab) < 0) {
        _dataTab.push(tab);
      }
    };

    this.onTabUpdated = function (tab, data) {};

    this.init();
  };

  jQuery.fn.gfModalNew = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfmodalnew')) {
        const plugin = new jQuery.gfModalNew(this, options);
        jQuery(this).data('gfmodalnew', plugin);
      }
    });
  };
})(jQuery);
